



















































































































































































import { Component, Vue } from "vue-property-decorator";
import ComponentsSidebar from "@/components/ComponentsSidebar.vue";
import ComponentType from "@/enums/ComponentType";
import FieldType from "@/enums/FieldType";
import ComponentModal from "@/components/ComponentModal.vue";
import ComponentConfigurations from "@/componentConfigurations/index"

@Component({
  components: {
    ComponentsSidebar
  }
})
export default class Home extends Vue {
  ComponentType = ComponentType;
  FieldType = FieldType;

  settings = {
    backgroundColor: "#2c2b30",
    textColor: "#2c2b30",
    fontFamily: "Arial, Helvetica, sans-serif",
    wrapperWidth: "800px",
    wrapperBackgroundColor: "#fefefe",
    previewMode: false
  };

  private currentEditComponent: any = null;
  private get currentEditComponentConfiguration() {
    return this.currentEditComponent !== null ? ComponentConfigurations.find(componentConfiguration => componentConfiguration.type === this.currentEditComponent.type) : null;
  }

  private dragCounter = 0;
  private currentDragTemplate = 0;

  private setCurrentDragTemplate(value: string) {
    console.log(value);
    this.currentDragTemplate = Number(value);
  }

  private dragenterHandler(event: any) {
    event.preventDefault();
    this.dragCounter++;

    if (event.target.classList && event.target.classList.contains("dropzone")) {
      event.target.style.background = "purple";
    }

    if (this.currentDragTemplate <= 0 || this.currentDragTemplate >= 7) {
      return;
    }

    if (this.dragCounter !== 1) return;

    console.log("dragenter");
  }

  private dragleaveHandler(event: any) {
    event.preventDefault();
    this.dragCounter--;

    if (event.target.classList && event.target.classList.contains("dropzone")) {
      event.target.style.background = "lightblue";
    }

    if (this.dragCounter !== 0) return;
  }

  private dropHandler(event: any) {
    event.preventDefault();
    this.dragCounter = 0;

    if (event.target.classList && event.target.classList.contains("dropzone")) {
      event.target.style.background = "lightblue";
    } else {
      return;
    }

    const componentType = event.target.getAttribute("componentType");
    let settings: any;

    switch (this.currentDragTemplate) {
      case ComponentType.HEADING:
        settings = {
          value: "change me"
        };

        break;

      case ComponentType.IMAGE:
        settings = {
          src: "https://images.unsplash.com/photo-1446034295857-c39f8844fad4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&h=200&q=80"
        };

        break;

      case ComponentType.DIVIDER:
        settings = {};

        break;

      case ComponentType.TEXT:
        settings = {
          text: "some text to change"
        };

        break;

      case ComponentType.SLIDESHOW:
        settings = {};

        break;

      case ComponentType.VIDEO:
        settings = {};

        break;
    }

    console.log(this.currentDragTemplate, settings);

    this.components.splice(Number(event.target.getAttribute("position")), 0, {
      type: this.currentDragTemplate,
      settings: settings
    });

    this.currentDragTemplate = 0;
  }

  private components: any = [
    {
      type: ComponentType.IMAGE,
      settings: {
        src: "https://images.unsplash.com/photo-1446034295857-c39f8844fad4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&h=200&q=80"
      }
    },
    {
      type: ComponentType.HEADING,
      settings: {
        value: "cool offer"
      }
    },
    {
      type: ComponentType.TEXT,
      settings: {
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse nec vestibulum neque. Integer accumsan, lectus at lacinia ullamcorper, magna dolor pulvinar libero, eu interdum dui justo non enim. Cras in rutrum nisl. Pellentesque in tempus mauris. Donec in faucibus libero. Sed consectetur id augue quis dictum. Suspendisse ac tempor dolor. Donec placerat, justo eget pretium interdum, nibh ante tincidunt enim, ac molestie enim dolor vitae elit. Aliquam fermentum ex ac ligula mollis, sit amet imperdiet massa tristique. Vestibulum ut imperdiet ante. Sed viverra tortor nec massa hendrerit pellentesque. Maecenas vehicula rutrum suscipit. Fusce finibus ligula purus, eu luctus urna tincidunt at. Vestibulum hendrerit eu elit in viverra. Pellentesque mollis, enim non ultricies egestas, metus neque imperdiet elit, blandit pretium libero orci quis justo. Fusce lacus arcu, luctus ut arcu vulputate, aliquet placerat dolor. "
      }
    }
  ];
}
